import type { ja } from '.'

// キーと値の間に改行が入ると翻訳システムと連携できなくなるため、prettier-ignoreしている
// prettier-ignore
export const locale = {
  'smarthr-ui/common/language': 'English',
  'smarthr-ui/ActionDialog/closeButtonLabel': 'Cancel',
  'smarthr-ui/AppHeader/school': 'SmartHR School',
  'smarthr-ui/AppHeader/help': 'Help',
  'smarthr-ui/AppHeader/userSettings': 'Personal Settings',
  'smarthr-ui/AppHeader/releaseNotes': 'Release Notes',
  'smarthr-ui/AppHeader/releaseNotesLoadError': 'Failed to load the release notes. Please try again later.',
  'smarthr-ui/AppHeader/seeAllReleaseNotes': 'View all release notes',
  'smarthr-ui/AppHeader/DesktopHeader/appLauncherLabel': 'Apps',
  'smarthr-ui/AppHeader/MobileHeader/account': 'Account',
  'smarthr-ui/AppHeader/MobileHeader/openMenu': 'Open menu',
  'smarthr-ui/AppHeader/MobileHeader/closeMenu': 'Close menu',
  'smarthr-ui/AppHeader/MobileHeader/allAppButton': 'All Apps',
  'smarthr-ui/AppHeader/MobileHeader/managementMenu': 'Admin Menu',
  'smarthr-ui/AppHeader/MobileHeader/latestReleaseNotes': 'Latest Release Notes',
  'smarthr-ui/AppHeader/MobileHeader/back': 'Back',
  'smarthr-ui/AppHeader/MobileHeader/openMenuAccordion': 'Open',
  'smarthr-ui/AppHeader/MobileHeader/closeMenuAccordion': 'Close',
  'smarthr-ui/AppHeader/Launcher/searchInputTitle': 'Enter the name of the App.',
  'smarthr-ui/AppHeader/Launcher/favoriteModeText': 'Favorite Apps',
  'smarthr-ui/AppHeader/Launcher/allModeText': 'All Apps',
  'smarthr-ui/AppHeader/Launcher/listText': 'App List',
  'smarthr-ui/AppHeader/Launcher/helpText': 'About Favorite Apps',
  'smarthr-ui/AppHeader/Launcher/searchResultText': 'Search results',
  'smarthr-ui/AppHeader/Launcher/emptyText': 'App not found.',
  'smarthr-ui/AppHeader/Launcher/sortDropdownLabel': 'Sort by',
  'smarthr-ui/AppHeader/Launcher/sortDropdownSelected': 'Selected',
  'smarthr-ui/AppHeader/Launcher/sortDropdownOrderDefault': 'Default order',
  'smarthr-ui/AppHeader/Launcher/sortDropdownOrderNameAsc': 'App name (A→Z)',
  'smarthr-ui/AppHeader/Launcher/sortDropdownOrderNameDesc': 'App name (Z→A)',
  'smarthr-ui/AppLauncher/showAllText': 'View all',
  'smarthr-ui/AppLauncher/triggerLabel': 'Apps',
  'smarthr-ui/Browser/notFoundDescription': 'Try changing the filter criteria.',
  'smarthr-ui/Browser/notFoundTitle': 'No items found.',
  'smarthr-ui/Button/loading': 'In Progress',
  'smarthr-ui/Calendar/currentYear': 'Current year',
  'smarthr-ui/Calendar/nextMonth': 'Next month',
  'smarthr-ui/Calendar/previousMonth': 'Previous month',
  'smarthr-ui/Calendar/selectYear': 'Select year',
  'smarthr-ui/Combobox/addItemButtonLabel': 'Add “{name}”',
  'smarthr-ui/Combobox/loadingText': 'In Progress',
  'smarthr-ui/Combobox/noResultsText': 'No matching results found.',
  'smarthr-ui/DropdownMenuButton/triggerActive': 'Hide options',
  'smarthr-ui/DropdownMenuButton/triggerInactive': 'Show options',
  'smarthr-ui/DropZone/selectButtonLabel': 'Choose file to upload',
  'smarthr-ui/FileViewer/rotateAlt': 'Rotate Left',
  'smarthr-ui/FileViewer/scaleDownAlt': 'Zoom Out',
  'smarthr-ui/FileViewer/scaleRateLabel': 'Zoom Factor (%)',
  'smarthr-ui/FileViewer/scaleUpAlt': 'Zoom In',
  'smarthr-ui/FileViewer/unsupportedFileText': 'Unsupported file format.',
  'smarthr-ui/FilterDropdown/applyText': 'Apply',
  'smarthr-ui/FilterDropdown/cancelText': 'Cancel',
  'smarthr-ui/FilterDropdown/resetText': 'Clear filters',
  'smarthr-ui/FilterDropdown/status': 'Filters applied',
  'smarthr-ui/FilterDropdown/triggerText': 'Filter',
  'smarthr-ui/FormDialog/closeButtonLabel': 'Cancel',
  'smarthr-ui/InformationPanel/closeButtonLabel': 'Close',
  'smarthr-ui/InformationPanel/openButtonLabel': 'Open',
  'smarthr-ui/InputFile/destroy': 'Delete',
  'smarthr-ui/LanguageSwitcher/checkIconAlt': 'Selected',
  'smarthr-ui/Loader/alt': 'In Progress',
  'smarthr-ui/MessageDialog/closeButtonLabel': 'Close',
  'smarthr-ui/ModelessDialog/closeButtonIconAlt': 'Close',
  'smarthr-ui/ModelessDialog/dialogHandlerAriaLabel': 'Dialog position',
  'smarthr-ui/ModelessDialog/dialogHandlerAriaRoleDescription': 'Can be dragged',
  'smarthr-ui/ModelessDialog/dialogHandlerDescription': 'Can be moved up, down, left, or right using arrow keys',
  'smarthr-ui/ModelessDialog/dialogHandlerLiveRegionText': '{top}px from top, {left}px from left',
  'smarthr-ui/MultiCombobox/destroyButtonIconAltSuffix': ': remove',
  'smarthr-ui/MultiCombobox/selectedListAriaLabel': 'Selected items',
  'smarthr-ui/NotificationBar/closeButtonIconAlt': 'Close',
  'smarthr-ui/Pagination/controllerItemButtonFirstLabel': 'First',
  'smarthr-ui/Pagination/controllerItemButtonLastLabel': 'Last',
  'smarthr-ui/Pagination/controllerItemButtonNextLabel': 'Next',
  'smarthr-ui/Pagination/controllerItemButtonPreviousLabel': 'Previous',
  'smarthr-ui/Pagination/itemButtonLabel': 'Page {page}',
  'smarthr-ui/Pagination/navigationLabel': 'Pagination',
  'smarthr-ui/RequiredLabel/text': 'Required',
  'smarthr-ui/SearchInput/iconAlt': 'Search',
  'smarthr-ui/SideMenu/navigationLabel': 'Sidebar',
  'smarthr-ui/SingleCombobox/destroyButtonIconAlt': 'Clear',
  'smarthr-ui/SortDropdown/applyText': 'Apply',
  'smarthr-ui/SortDropdown/ascLabel': 'Ascending',
  'smarthr-ui/SortDropdown/cancelText': 'Cancel',
  'smarthr-ui/SortDropdown/descLabel': 'Descending',
  'smarthr-ui/SortDropdown/sortFieldLabel': 'Sort items',
  'smarthr-ui/SortDropdown/sortOrderLegend': 'Order',
  'smarthr-ui/StepFormDialog/backButtonLabel': 'Back',
  'smarthr-ui/StepFormDialog/closeButtonLabel': 'Cancel',
  'smarthr-ui/StepFormDialog/nextButtonLabel': 'Next',
  'smarthr-ui/StepStatusIcon/closedAlt': 'Interrupted',
  'smarthr-ui/StepStatusIcon/completedAlt': 'Completed',
  'smarthr-ui/Textarea/availableLetters': '{availableLetters} characters left',
  'smarthr-ui/Textarea/maxLettersExceeded': '{exceededLetters} characters over limit',
  'smarthr-ui/Textarea/screenReaderMaxLettersDescription': 'Maximum {maxLetters} characters',
  'smarthr-ui/OpenInNewTabIcon/openInNewTab': 'Open in another tab',
  'smarthr-ui/Th/sortDirectionAsc': 'Ascending',
  'smarthr-ui/Th/sortDirectionDesc': 'Descending',
  'smarthr-ui/Th/sortDirectionNone': 'No sorting',
  'smarthr-ui/ThCheckbox/checkAllInvisibleLabel': 'Select/Deselect All',
  'smarthr-ui/ThCheckbox/checkColumnName': 'Select',
} as const satisfies Record<keyof typeof ja, string>
